import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @Input() imageUrl!: string;

  @Input() heading!: string;

  @Input() description!: string;

  @Input() bgColor: string = '#e1f4ff';

  constructor() {}
}
